import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function UrgencySection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-338">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-339">
        <div className="text-center mb-8" data-id="element-340">
          <AlertTriangleIcon className="w-12 h-12 text-red-400 mx-auto mb-4" data-id="element-341" />
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white" data-id="element-342">
            Esto Tiene Fecha de Vencimiento — Y No Es Exageración
          </h2>
        </div>

        <div className="space-y-6 text-gray-200" data-id="element-343">
          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-344">
            El IRS solo permite enmendar declaraciones de los últimos 3 años.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-345">
            Eso significa que cada día que pasa sin actuar sobre esto... es un
            día menos que tienes para reclamar lo que te deben de años
            anteriores.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-346">
            No es presión de ventas. Es matemática del IRS.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-347">
            Si el año 2022 está en tu ventana de enmienda hoy... en unos meses
            ya no lo estará.
          </p>

          <div className="bg-red-900/20 p-6 rounded-xl border border-red-500/20 my-4" data-id="element-348">
            <p className="text-xl md:text-2xl leading-relaxed text-red-300 font-semibold text-center" data-id="element-349">
              Ese dinero no se transfiere. No se guarda para después. Se va.
            </p>
          </div>

          <p className="text-2xl md:text-3xl leading-relaxed font-bold text-white text-center pt-4" data-id="element-350">
            ¿Vas a dejar que se vaya?
          </p>
        </div>
      </div>
    </section>;
}